import { createContext, useContext, type ReactNode } from 'react';
import { createPortal } from 'react-dom';

/** The `<TopNav>` element pages portal their header control into. */
export const HeaderSlotContext = createContext<HTMLElement | null>(null);

/**
 * Renders `children` into `<TopNav>`'s per-page slot. The header search is
 * opt-in: a page that wants one renders `<HeaderSlot>`, and a page that does
 * not — the Map, for one — simply gets no search (grilling Q7).
 */
export function HeaderSlot({ children }: { children: ReactNode }) {
  const el = useContext(HeaderSlotContext);
  return el ? createPortal(children, el) : null;
}
